'use client'

import { Image, Spacer, Text } from '@vinted/web-ui'

import { useTracking } from '@marketplace-web/observability/event-tracker-data'
import { useTranslate } from '@marketplace-web/i18n/i18n-feature'
import { useAsset } from '@marketplace-web/shared/assets'

import { clickEvent } from '@marketplace-web/safety/safety-data'

import ResponsiveWrapper from '../ReponsiveWrapper'

const TransparencyReportSection = () => {
  const translate = useTranslate('transparency_report')

  const { track } = useTracking()

  const asset = useAsset()

  const handleDownloadClick = (year: number) => () => {
    track(
      clickEvent({
        target: 'download_transparency_report',
        targetDetails: JSON.stringify({
          year,
        }),
      }),
    )
  }

  return (
    <section className="page-section__facts">
      <div className="page-section__fact-single-block">
        <div className="page-section__fact-illustration">
          <Image src={asset('images/safety/illustrations/document.svg')} alt="" />
        </div>
        <ResponsiveWrapper
          mobile={<Spacer size={Spacer.Size.XLarge} />}
          desktop={<Spacer size={Spacer.Size.XLarge} orientation={Spacer.Orientation.Vertical} />}
        />
        <div className="page-section__content">
          <Text as="h3">
            <div className="safety_fact-title">{translate('title')}</div>
          </Text>
          <ResponsiveWrapper mobile={<Spacer />} desktop={<Spacer size={Spacer.Size.Large} />} />
          <Text as="span" html>
            <div className="safety_body">{translate('description')}</div>
          </Text>
          <Spacer size={Spacer.Size.Large} />
          <a
            href={asset('transparency-report/vinted-transparency-report-2024.xlsx')}
            onClick={handleDownloadClick(2024)}
          >
            <Text as="span" theme="primary" html clickable>
              {translate('download', {
                year: 2024,
              })}
            </Text>
          </a>
        </div>
      </div>
    </section>
  )
}

export default TransparencyReportSection
